import { type FC, useId } from "react";
import { Tooltip } from "react-tooltip";
import { Button, ButtonProps } from "./Button";

type TooltipButtonProps = ButtonProps & {
	tooltip?: string;
	tooltipId?: string;
};

export const TooltipButton: FC<TooltipButtonProps> = ({
	disabled,
	tooltip,
	tooltipId,
	children,
	...props
}) => {
	const id = tooltipId ?? `tooltip-${useId()}`;
	return (
		<div className="relative w-full">
			{disabled && <Tooltip id={id} className="absolute" />}
			<Button
				disabled={disabled}
				data-tooltip-id={id}
				data-tooltip-content={tooltip}
				className="w-full"
				{...props}
			>
				{children}
			</Button>
		</div>
	);
};
